import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";

import { Auth0Provider } from "@auth0/auth0-react";
import { EventRequirementProvider } from "./context/EventRequirementContext"; // ✅ ADD THIS
import { GoogleOAuthProvider } from "@react-oauth/google";

import { GOOGLE_CLIENT_ID } from "./config/googleOAuth"; // ✅ IMPORT GOOGLE_CLIENT_ID

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <Auth0Provider
            domain="gopratle.us.auth0.com"
            clientId="m82SWLXZ83BNqzz3KiZRhkhV3Ydxt2rk"
            authorizationParams={{
              redirect_uri: window.location.origin,
            }}
          >
            {/* ✅ CONTEXT AT ROOT */}
            <EventRequirementProvider>
              <App />
            </EventRequirementProvider>
          </Auth0Provider>
        </GoogleOAuthProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
